import { Component,OnInit,OnDestroy,AfterViewInit} from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
} from "src/app/shared/service";

@Component({
    templateUrl: './dtg.car.last.total.component.html'
    ,styleUrls: ["./dtg.car.last.total.component.scss"]
    ,providers: []
    ,animations: [
        trigger('listAnimation', [
            state('true', style({ opacity: 1 }))
            ,state('false', style({ opacity: 0 }))
            ,transition('true => false', animate('600ms'))
            ,transition('false => true', animate('300ms'))
        ])
    ]
})
export class DtgCarLastTotalComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    companyInfo:any;
    selectedCarInfo:any;
    apiType:string;

    constructor(
        private fvmsCommonService: FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.apiType = this.currentUserInfo.apiType;
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }
}